module.exports = __webpack_public_path__ + "static/media/configuracoes-icon.bc8af4a9.svg";